import { NetworkPortfolioManagementProject } from "@app/network-portfolio-management/interfaces";

// Builds the Needs Attention hover text. The backend already role-gates these flags, so any that are true apply to
// the current viewer; the Needs Attention status itself is computed on the backend. Shared by every
// ProjectStatusDisplay consumer (card view, tabular view) so the message set + wording stay in one place.
export const unprocessedActionMessages = (project: NetworkPortfolioManagementProject): string[] =>
  [
    { message: "Unprocessed Provider Terminations", show: project.hasUnprocessedProviderTerminations },
    { message: "Unprocessed Targeted or Excluded Providers", show: project.hasUnprocessedProjectionProviders },
    { message: "Unprocessed Specialty Group Exceptions", show: project.hasUnprocessedSpecialtyGroupExceptions },
  ]
    .filter((item) => item.show)
    .map((item) => item.message);
